import React, { useState } from 'react';
import { Button, FailIcon, Group, Input, Label, VisibilityIcon, VisibilityOffIcon } from '@tlx/atlas';
import { useIntl } from 'react-intl';

interface PasswordProps {
    id: string;
    label: string;
    pwd: string;
    setPwd: (value: string) => void;
    small?: boolean;
    defaultVisible?: boolean; //mostly for storybook
    errorMessage?: string;
    onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}
export function PasswordInput({ id, label, pwd, setPwd, small, defaultVisible, errorMessage, onEnter }: PasswordProps) {
    const [pwdVisible, setPwdVisible] = useState(defaultVisible);
    const intl = useIntl();

    return (
        <div className="PasswordContainer">
            <Group>
                <Label htmlFor={id}>{label}</Label>
                <div className="PasswordInputContainer">
                    <Input
                        className={`PasswordInput ${
                            small ? 'PasswordSmall' : ''
                        } ${errorMessage ? 'tsk-input--error' : ''}`}
                        data-testid={id}
                        key={id}
                        id={id}
                        type={pwdVisible ? 'text' : 'password'}
                        required
                        value={pwd}
                        onChange={(event) => {
                            setPwd(event.target.value);
                        }}
                        onKeyDown={(e) => {
                            onEnter?.(e);
                        }}
                        autoComplete="password"
                        data-1p-ignore
                        data-lpignore
                    />
                    <Button
                        className={`PasswordShowHideButton ${errorMessage ? 'tsk-input--error' : ''}`}
                        variant="icon"
                        aria-label={intl.formatMessage({
                            id: pwdVisible ? 'text_hide' : 'text_show',
                        })}
                        disabled={pwd.length == 0 && !pwdVisible}
                        data-testid={'visibility-button'}
                        onClick={() => setPwdVisible((prev) => !prev)}
                    >
                        {pwdVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </Button>
                </div>
            </Group>
            {errorMessage && (
                <div className="atl-flex atl-gap-8 atl-mt-8">
                    <FailIcon size="small" className="atl-text-red-100" />
                    <div className="tsk-input__errorMessage">{errorMessage}</div>
                </div>
            )}
        </div>
    );
}
